import { BaseClass } from "./base-class";
import { Client } from "./client";

export class License extends BaseClass {
    public client: Client;
    public startDate: Date;
    public endDate: Date;
    public monthlyPrice: number;
    public pricePerExtraOrder: number;
    public maxOrdersPerMonth: number;
    public comment: string;
}